import {FC} from 'react';
import {Tooltip} from '@mui/material';

import {ThemeMode, useThemeMode} from 'theme/ThemeModeProvider';
import styles from './ThemeToggle.module.scss';

interface Props {
  /** Свёрнутый сайдбар: вместо трёх кнопок — одна иконка-переключатель. */
  compact?: boolean;
}

const OPTIONS: {value: ThemeMode; label: string}[] = [
  {value: 'light', label: 'Light'},
  {value: 'dark', label: 'Dark'},
  {value: 'system', label: 'Auto'},
];

const SunIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <circle cx="12" cy="12" r="4.25" stroke="currentColor" strokeWidth="1.5" />
    <path
      d="M12 2.5V4.5M12 19.5V21.5M4.5 12H2.5M21.5 12H19.5M6.7 6.7L5.3 5.3M18.7 18.7L17.3 17.3M6.7 17.3L5.3 18.7M18.7 5.3L17.3 6.7"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

const MoonIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M20 13.4A8 8 0 1 1 10.6 4a6.5 6.5 0 0 0 9.4 9.4Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);

/**
 * Переключатель темы: Light / Dark / Auto.
 * Auto — синхронизация с системой (задача #64), выбор запоминается.
 */
const ThemeToggle: FC<Props> = ({compact}) => {
  const {mode, resolved, setMode} = useThemeMode();

  if (compact) {
    const next: ThemeMode = resolved === 'dark' ? 'light' : 'dark';
    return (
      <Tooltip
        title={resolved === 'dark' ? 'Light theme' : 'Dark theme'}
        placement="right"
        arrow
      >
        <button
          type="button"
          className={styles.compactButton}
          aria-label="Switch theme"
          onClick={() => setMode(next)}
        >
          {resolved === 'dark' ? <SunIcon /> : <MoonIcon />}
        </button>
      </Tooltip>
    );
  }

  return (
    <div className={styles.wrapper}>
      <span className={styles.label}>Theme</span>
      <div className={styles.options}>
        {OPTIONS.map((option) => (
          <button
            key={option.value}
            type="button"
            className={`${styles.option} ${
              mode === option.value ? styles.optionActive : ''
            }`}
            onClick={(event) => {
              // клик не должен закрывать меню профиля
              event.stopPropagation();
              setMode(option.value);
            }}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ThemeToggle;
